/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Dashboard
 *| (C) Copyright IBM Corp. 2018, 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define([
	'../../../lib/@waca/upgrades/UpgradeBase',
	'./utils/WidgetUpgradeUtils',
	'jquery'
], (UpgradeBase, WidgetUpgradeUtils, $) => {

	const TEXT_WIDGET_TYPE = 'text';

	class TextWidgetParagraphUpgrade extends UpgradeBase {

		constructor() {
			super();
			this.VERSION = 1026;
		}

		/**
		 * Perform upgrades for TextWidgets before support for numbered and unordered lists were added.
		 * The default classes previously applied to the paragraph tag need to be moved up because adding
		 * list replaces the paragraph tag.
		 *
		 * @param {object} spec - spec to perform upgrade on
		 *
		 * @return {Promise} Promise to be resolved when upgrade performed
		 */
		up(spec) {
			if (!spec) {
				return Promise.resolve(spec);
			}
			if (!WidgetUpgradeUtils.specHasWidgets(spec)) {
				return Promise.resolve(spec);
			}

			return this._upgradeWidgets(spec);
		}

		_upgradeWidgets(spec) {
			for (var widget in spec.widgets) {
				const model = spec.widgets[widget];
				if (model.type === TEXT_WIDGET_TYPE && model.content) {
					this._upgradeTextWidget(model);
				}
			}
			return Promise.resolve(spec);
		}

		_upgradeTextWidget(model) {
			const table = model.content.translationTable;
			if (table) {
				for(const lang in table) {
					table[lang] = this._upgradeContent(table[lang]);
				}
			} else if (typeof model.content === 'string') {
				model.content = this._upgradeContent(model.content);
			}
		}

		_upgradeContent(content) {
			const $content = $(content);
			const $paragraphs = $content.find('p');
			const $textFitted = $content.find('.textFitted');
			const className = $paragraphs.first().attr('class');
			$paragraphs.removeAttr('class');
			if ($textFitted.length) {
				$textFitted.addClass(className);
			} else {
				const $span = $(`<span class='textFitted ${className}'/>`);
				$paragraphs.wrapAll($span);
			}
			return $content.wrap('<div/>').parent().html();
		}
	}

	return new TextWidgetParagraphUpgrade();

});
